import React from 'react';
import PropTypes from 'prop-types';
import './Card.scss';

export const Card = ({
  children,
  title,
  subtitle,
  className = '',
  onClick,
  hoverable = false,
  loading = false,
  ...props
}) => {
  const cardClasses = [
    'card',
    className,
    hoverable ? 'card--hoverable' : '',
    loading ? 'card--loading' : '',
    onClick ? 'card--clickable' : ''
  ].filter(Boolean).join(' ');

  const CardContent = () => (
    <>
      {(title || subtitle) && (
        <div className="card__header">
          {title && <h3 className="card__title">{title}</h3>}
          {subtitle && <p className="card__subtitle">{subtitle}</p>}
        </div>
      )}
      <div className="card__content">
        {loading ? (
          <div className="card__loading">
            <div className="spinner"></div>
          </div>
        ) : (
          children
        )}
      </div>
    </>
  );

  if (onClick) {
    return (
      <button
        className={cardClasses}
        onClick={onClick}
        type="button"
        {...props}
      >
        <CardContent />
      </button>
    );
  }

  return (
    <div className={cardClasses} {...props}>
      <CardContent />
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  hoverable: PropTypes.bool,
  loading: PropTypes.bool
};